module.exports = __webpack_public_path__ + "img/jm.393232d9.svg";